import axios from "axios";

/**
 * Configuração centralizada do Axios para todos os serviços
 */

const getApiUrl = () => {
  return (
    window.ENV?.REACT_APP_API_URL ||
    process.env.REACT_APP_API_URL ||
    "/api"
  );
};

const API_URL = getApiUrl();

// Determinar se estamos em stage
const isStageEnvironment = () => {
  return window.ENV?.REACT_APP_ENV === 'stage' ||
         process.env.REACT_APP_ENV === 'stage';
};

// Configurar headers baseado no ambiente
const getHeaders = () => {
  // Apenas adicionar headers no-cache em STAGE, não em produção
  if (isStageEnvironment()) {
    console.log('🚫 Axios: Cache desabilitado para ambiente STAGE');
    return {
      'Cache-Control': 'no-cache, no-store, must-revalidate',
      'Pragma': 'no-cache',
      'Expires': '0'
    };
  }
  // Produção usa cache normal
  return {};
};

// Criar instância do Axios com configurações padrão
const axiosInstance = axios.create({
  baseURL: API_URL,
  headers: getHeaders()
});

// Interceptor para adicionar logs em desenvolvimento
if (process.env.NODE_ENV === 'development' || window.ENV?.REACT_APP_ENV === 'stage') {
  axiosInstance.interceptors.request.use(
    (config) => {
      console.log(`🌐 API Request: ${config.method?.toUpperCase()} ${config.url}`);
      return config;
    },
    (error) => {
      console.error('❌ API Request Error:', error);
      return Promise.reject(error);
    }
  );

  axiosInstance.interceptors.response.use(
    (response) => {
      console.log(`✅ API Response: ${response.config.method?.toUpperCase()} ${response.config.url} - ${response.status}`);
      return response;
    },
    (error) => {
      console.error(`❌ API Response Error: ${error.config?.method?.toUpperCase()} ${error.config?.url} - ${error.response?.status || 'Network Error'}`);
      return Promise.reject(error);
    }
  );
}

export { axiosInstance, API_URL };
